import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 365px;
    background: red;
    margin: 0 auto 20px;
    padding: 15px;
    border-radius: 5px;
    border: solid 1px red;

    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
`;